import { useState } from 'react';
import CaktoApiCreateApikeyConfirmationDialog from './CaktoApiCreateApikeyConfirmationDialog';
import CreateApiKeyButton from './CreateApiKeyButton';


export default function CreateApiKeyDialog() {
    const [apiKeyInfo, setApiKeyInfo] = useState(null);

    return (
        <>
            <CreateApiKeyButton setApiKeyInfo={setApiKeyInfo} />
            {apiKeyInfo && <CaktoApiCreateApikeyConfirmationDialog apiKeyInfo={apiKeyInfo} />}
        </>
    )
}